import { ProductSheetTabRoutes } from '@applications/order-tracker/config/order-tracker-new-common/constants';

export const getProductNameAndTab = (pathname: string) => {
  const { productNumber, currentTab } = (
    pathname?.split('/product/')[1]?.split('/') || []
  ).reduce(
    (acc, val, i) => ({
      ...acc,
      [i === 0 ? 'productNumber' : 'currentTab']: val || null,
    }),
    { productNumber: null, currentTab: null }
  );
  return {
    productNumber,
    currentTab:
      productNumber && !isValidTab(currentTab)
        ? ProductSheetTabRoutes.ProductDetails
        : currentTab,
  };
};

const isValidTab = (tab: string) => tab === ProductSheetTabRoutes.ProductDetails || tab === ProductSheetTabRoutes.ProgressTracker
